export const INTYG_FILE_MIMETYPES = 'application/pdf,image/jpeg,image/jpg';

export const BASE_URL = '/_api/intyg';
export interface FilKompletteringDocumentListItem {
  fileName: string;
  url: string;
  fileExtension: string;
  fileId: string;
}

export interface PostFilesServerResponseObject {
  FileId: string;
  kompletteringId: string;
  OriginalFilename: string;
}
